import { IBaseIconProps } from "./IBaseIconProps";

export const FamilyIcon = ({ color = "#000" }: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="-5.0 -10.0 110.0 135.0"
    >
      <path
        d="M10.6,50.9h7.9v36.4h63V50.9h7.9c2.7,0,4.1-3.3,2.2-5.3l-39.4-32c-1.2-1.3-3.3-1.3-4.5,0l-39.4,32  C6.5,47.6,7.9,50.9,10.6,50.9z M39.6,78.6v-3.5c0-4.4,2.8-8.2,6.7-9.7c1.2-0.5,2.4-0.7,3.7-0.7c1.3,0,2.6,0.3,3.7,0.7  c3.9,1.5,6.7,5.3,6.7,9.7v3.5v3H39.6V78.6z M43.3,54.5c0.1-1.1,0.4-2.1,0.9-3c1.2-2,3.4-3.4,5.9-3.4c2.5,0,4.7,1.4,5.9,3.4  c0.5,0.9,0.8,1.9,0.9,3c0,0.1,0,0.2,0,0.3c0,3.7-3,6.7-6.7,6.7c-3.7,0-6.7-3-6.7-6.7C43.3,54.7,43.3,54.6,43.3,54.5z M74.9,71.2v7.5  H62.4v-3.5c0-5.1-3.1-9.4-7.4-11.3c2.1-2.4,5.2-4,8.6-4C69.8,59.8,74.9,64.9,74.9,71.2z M63.6,43.2c4.3,0,7.7,3.5,7.7,7.7  s-3.5,7.7-7.7,7.7c-1.9,0-3.7-0.7-5.1-1.9c0.1-0.6,0.2-1.2,0.2-1.9c0-2.4-1-4.6-2.6-6.2C57.1,45.5,60.1,43.2,63.6,43.2z M36.4,43.2  c3.5,0,6.4,2.3,7.4,5.5c-1.6,1.6-2.6,3.8-2.6,6.2c0,0.7,0.1,1.3,0.2,1.9c-1.4,1.2-3.1,1.9-5.1,1.9c-4.3,0-7.7-3.5-7.7-7.7  S32.2,43.2,36.4,43.2z M25.1,71.2c0-6.3,5.1-11.4,11.4-11.4c3.5,0,6.5,1.5,8.6,4c-4.4,1.9-7.4,6.3-7.4,11.3v3.5H25.1V71.2z"
        fill={color}
      />
    </svg>
  );
};
